export const lightTheme = {
    // mode: ThemeMode.LIGHT,
    colors: {
        primary: '#0E4A64', // Azul Escuro MOB
        primaryLight: '#166284',
        secondary: '#D57530', // Laranja MOB
        secondaryLight: '#E68B4D',
        background: '#F8FAFC', // Cinza azulado muito claro
        paper: '#FFFFFF',
        text: '#1A202C', // Quase preto
        textSecondary: '#4A5568',
        textMuted: '#64748b', // For captions/disabled
        border: '#E2E8F0',
        divider: '#EDF2F7',

        // Semantic Status Colors
        success: '#2D8A5E',
        successBg: 'rgba(45, 138, 94, 0.15)',
        danger: '#A5232F',
        dangerBg: 'rgba(165, 35, 47, 0.15)',
        warning: '#D97706',
        warningBg: 'rgba(217, 119, 6, 0.15)',
        info: '#0D6EFD',
        infoBg: 'rgba(13, 110, 253, 0.15)',

        // Grays
        gray50: '#F8FAFC',
        gray100: '#F1F5F9',
        gray200: '#E2E8F0',
        gray300: '#CBD5E1',
        gray400: '#94A3B8',
        gray500: '#64748B',

        particleColor: '#CBD5E0',

        // Action colors
        action: '#00C2E0',
        actionLight: '#00d4f5',
        actionDark: '#0a4d68',
        actionShadow: 'rgba(0, 194, 224, 0.35)',

        // Headers
        headerBg: '#011629',
        headerHoverBg: '#000f19',
        headerText: '#ffffff',
        headerTextMuted: '#cbd5e1',
        headerAccent: '#1CA5D9',
        headerBorder: 'rgba(148, 163, 184, 0.18)',

        // Shadows
        shadowSm: '0 1px 3px rgba(0, 0, 0, 0.08)',
        shadowMd: '0 4px 12px rgba(0, 0, 0, 0.12)',
        shadowLg: '0 10px 25px rgba(0, 0, 0, 0.15)',

        // Charts (kept as is)
        chartPalette: [
            '#3B82F6',
            '#6366F1',
            '#8B5CF6',
            '#A855F7',
            '#C084FC',
        ],
        chartPaletteHover: [
            '#2563EB',
            '#4F46E5',
            '#7C3AED',
            '#9333EA',
            '#A855F7',
        ],
        chartSuccess: '#22C55E',
        chartSuccessBg: 'rgba(34, 197, 94, 0.1)',
        chartError: '#EF4444',
        chartErrorBg: 'rgba(239, 68, 68, 0.1)',
        chartErrorHover: '#DC2626',
        chartPaletteExtended: [
            '#3B82F6',
            '#8B5CF6',
            '#EC4899',
            '#F97316',
            '#22C55E',
            '#14B8A6',
            '#EAB308',
            '#6366F1',
            '#F43F5E',
            '#06B6D4',
        ],
    },
};
